import { TextStyle, Platform } from 'react-native';
import { createTheming } from '@callstack/react-theme-provider';

export const colors = {
  aloe: '#bedcc8',
  beige: '#f0e6dc',
  beigeLight: '#f7f2ed',
  black: '#000000',
  error: 'red',
  errorLight: '#F4A598',
  gray: '#c6c7ce',
  grayLight: '#f0f0f0',
  night: '#343754',
  nightLight: '#727589',
  nightMedium: '#4b4e68',
  pink: '#f8d0c5',
  pinkLight: '#f7e1da',
  white: '#ffffff',
  yellow: '#ffe664',
  yellowLight: '#fcf6d6',
  blue: '#00ACE8'
};

interface Theme {
  fonts: Record<string, Record<string, TextStyle>>;
  colors: typeof colors;
}

export const theme: Theme = {
  fonts: {
    serif: {
      bold: {
        fontFamily: Platform.select({
          ios: 'DomaineDisplay-Bold',
          web: 'DomaineDisplay'
        }),
        fontWeight: 'bold',
        fontStyle: 'normal'
      },
      boldItalic: {
        fontFamily: Platform.select({
          ios: 'DomaineDisplay-BoldItalic',
          web: 'DomaineDisplay'
        }),
        fontWeight: 'bold',
        fontStyle: 'italic'
      },
      italic: {
        fontFamily: Platform.select({
          ios: 'DomaineDisplay-Italic',
          web: 'DomaineDisplay'
        }),
        fontWeight: 'normal',
        fontStyle: 'italic'
      },
      reg: {
        fontFamily: Platform.select({
          ios: 'DomaineDisplay-Regular',
          web: 'DomaineDisplay'
        }),
        fontWeight: 'normal',
        fontStyle: 'normal'
      }
    },
    sans: {
      bold: {
        fontFamily: Platform.select({
          ios: 'FoundersGroteskText-Bold',
          web: 'FoundersGroteskText'
        }),
        fontWeight: 'bold',
        fontStyle: 'normal'
      },
      light: {
        fontFamily: Platform.select({
          ios: 'FoundersGroteskText-Light',
          web: 'FoundersGroteskText'
        }),
        fontWeight: '100',
        fontStyle: 'normal'
      },
      semiBold: {
        fontFamily: Platform.select({
          ios: 'FoundersGroteskText-SemiBold',
          web: 'FoundersGroteskText'
        }),
        fontWeight: '300',
        fontStyle: 'normal'
      },
      //TODO: Add the correct italic font
      italic: {
        fontFamily: Platform.select({
          ios: 'FoundersGroteskText-Light',
          web: 'FoundersGroteskText'
        }),
        fontWeight: '100',
        fontStyle: 'italic'
      }
    },
    mono: {
      bold: {
        fontFamily: Platform.select({
          ios: 'Pitch-Bold',
          web: 'Pitch'
        }),
        fontWeight: 'bold',
        fontStyle: 'normal'
      },
      boldItalic: {
        fontFamily: Platform.select({
          ios: 'Pitch-BoldItalic',
          web: 'Pitch'
        }),
        fontWeight: 'bold',
        fontStyle: 'italic'
      },
      italic: {
        fontFamily: Platform.select({
          ios: 'Pitch-Italic',
          web: 'Pitch'
        }),
        fontWeight: 'normal',
        fontStyle: 'italic'
      },
      reg: {
        fontFamily: Platform.select({
          ios: 'Pitch-Regular',
          web: 'Pitch'
        }),
        fontWeight: 'normal',
        fontStyle: 'normal'
      }
    },
    // TODO: Need the roboto font to add here. Put Pitch in place to stub
    roboto: {
      reg: {
        fontFamily: Platform.select({
          ios: 'Pitch-Regular',
          web: 'Pitch'
        }),
        fontWeight: 'normal',
        fontStyle: 'normal'
      }
    }
  },
  colors
};

export const { ThemeProvider, useTheme } = createTheming(theme);
